import { generateClient, GraphQLResult } from "aws-amplify/api";
// @ts-ignore
import { getFormTemplate } from "../graphql/queries";
import { recordSentry } from "./recordSentry";
import { FormTemplate } from "db/definitions";

interface QueryResponse {
	getFormTemplate: FormTemplate;
}

export async function getSingleFormTemplateDoc(id: string): Promise<FormTemplate | undefined> {
	try {
		if (id) {
			const client = generateClient({ authMode: "userPool" });
			const result = (await client.graphql({
				query: getFormTemplate,
				variables: {
					id,
				},
				authMode: "userPool",
			})) as GraphQLResult<QueryResponse>;

			const formTemplate = result.data.getFormTemplate;
			return formTemplate;
		}
	} catch (error) {
		recordSentry({ error, msg: "Error getting full form template: " });
	}
}
